import React from 'react';

import { TableCell, TableHeaderCell } from '@hcs/design-system';
import { TableCellProps, TableHeaderCellProps } from '@hcs/types';
import {
  CompFieldConfig,
  CompFields,
  CompFieldsArgs,
  CompFieldsTableCellProps,
} from '@hcs/types';
import { formatPercent } from '@hcs/utils';

const FIELD = CompFields.hcAdjustmentPercent;
type FieldConfig = CompFieldConfig<typeof FIELD>;
// we don't use this label in the UI, but it's required for the config
const label = '';
const labelShort = '';
const compPath: FieldConfig['compPath'] = '/hcAdjustments/percent';
const getValue: FieldConfig['getValue'] = (comp) =>
  comp?.hcAdjustments?.percent;
const formatValue: FieldConfig['formatValue'] = (comp) =>
  formatPercent(getValue(comp), true);
const formatInline: FieldConfig['formatInline'] = (comp) => formatValue(comp);
// Component for displaying a field from a comp
// eslint-disable-next-line react-refresh/only-export-components
const Display = ({ comp }: CompFieldsArgs) => {
  return <>{formatValue(comp)}</>;
};

// eslint-disable-next-line react-refresh/only-export-components
const HeaderCell = (props: TableHeaderCellProps) => {
  return <TableHeaderCell {...props}>{labelShort}</TableHeaderCell>;
};
// Using default props allows for child.props checks
// in the Table components to work properly
const defaultHeaderProps: Partial<TableHeaderCellProps> = {
  align: 'right',
  // Needed so child component type-checking passes
  isTableHeaderCell: true,
};
HeaderCell.defaultProps = defaultHeaderProps;

// eslint-disable-next-line react-refresh/only-export-components
const ContentCell = ({ comp, ...tableCellProps }: CompFieldsTableCellProps) => {
  return (
    <TableCell {...tableCellProps}>
      <Display comp={comp} />
    </TableCell>
  );
};
// Using default props allows for child.props checks
// in the Table components to work properly
const defaultContentProps: Partial<TableCellProps> = {
  align: 'right',
  // Needed so child component type-checking passes
  isTableCell: true,
};
ContentCell.defaultProps = defaultContentProps;

export const HC_ADJUSTMENT_PERCENT_CONFIG: FieldConfig = {
  field: FIELD,
  label,
  labelShort,
  compPath,
  getValue,
  formatValue,
  formatInline,
  HeaderCell,
  ContentCell,
  Display,
};
